export default "__VITE_ASSET__Bc$O8GCx__"